
import Swiper from 'vux/src/components/swiper/swiper.vue'
import XTable from 'vux/src/components/x-table/index.vue'

import Goods from '../../models/goods/goods'
export default {
name: "detail",
components: {Swiper,XTable},
data(){
return{
isShowDescMask:false,
imgUrlArr:[],
detail:{
title:'',
price:'',
proDetailArr:[],
descArr:[],
imgUrlArr:[],
assays: []
}
}
},
mounted(){
const sku = this.$route.query.sku;
Goods.getDetail(sku).then((res)=>{
res = res.data;
this.detail = {
title: res.data.goodsName,
price:res.data.salePrice,
isSoldOut:res.data.isSoldOut
};
let detailImgUrlArr =[],imgUrlArr=[];
for(let i in res.data.images){
let imgUrl = res.data.images[i].imageUrl.replace('h_{height},w_{width}', "h_600,w_600");
detailImgUrlArr.push(imgUrl);
imgUrlArr.push({
img:imgUrl
})
}
this.detail.imgUrlArr = detailImgUrlArr;
this.imgUrlArr = imgUrlArr;
this.detail.proDetailArr = res.data.attribute;
this.detail.descArr = res.data.quality;
this.detail.assays = res.data.assays;

})
},
methods:{}
}



// WEBPACK FOOTER //
// ./src/components/homepage/detail.vue